import { useCallback, useEffect, useState } from 'react';

import { hrApi } from '@/api';

import { EmployeeSelect } from '@/components/selects';

import { PageHeader } from '@/components/layout/PageHeader';

import { Button } from '@/components/ui/Button';

import { Input } from '@/components/ui/Input';

import { DatePicker } from '@/components/ui/DatePicker';

import { FormGrid } from '@/components/ui/FormGrid';

import { showApiError } from '@/utils/apiError';

import { RecordDataTable } from '@/components/ui/RecordDataTable';
import { notify } from '@/core/toast/notify';



export function HrTravelPage() {

  const [requests, setRequests] = useState<unknown[]>([]);

  const [employeeId, setEmployeeId] = useState('');

  const [purpose, setPurpose] = useState('');

  const [destination, setDestination] = useState('');

  const [departure, setDeparture] = useState('');



  const load = useCallback(async () => {

    try {

      setRequests(await hrApi.listTravel());

    } catch (err) {

      showApiError(err, 'Failed to load travel requests');

    }

  }, []);



  useEffect(() => {

    load();

  }, [load]);



  const submit = async () => {

    try {

      await hrApi.createTravel({ employeeId: Number(employeeId), purpose, destination, departureDate: departure });

      notify.success('Travel request submitted');

      load();

    } catch (err) {

      showApiError(err, 'Submit failed');

    }

  };



  return (

    <div>

      <PageHeader title="Travel management" description="Travel requests, approval, and settlement" breadcrumbs={[{ label: 'HR', to: '/hr' }, { label: 'Travel' }]} />

      <FormGrid columns={2} className="card mb-4 p-4">

        <EmployeeSelect value={employeeId} onChange={setEmployeeId} />

        <Input label="Destination" value={destination} onChange={(e) => setDestination(e.target.value)} />

        <Input label="Purpose" value={purpose} onChange={(e) => setPurpose(e.target.value)} />

        <DatePicker label="Departure" value={departure} onChange={setDeparture} />

        <Button onClick={() => void submit()}>Submit request</Button>

      </FormGrid>

      <RecordDataTable data={requests} emptyTitle="No travel requests" />

    </div>

  );

}


